// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: shared/api/common/ENUM_UnsubscribeCodeType.proto

export enum ENUM_UnsubscribeCodeType {
  UNSUBSCRIBE_CODE_TYPE_UNSPECIFIED = 'UNSUBSCRIBE_CODE_TYPE_UNSPECIFIED',
  UNSUBSCRIBE_CODE_TYPE_ALL = 'UNSUBSCRIBE_CODE_TYPE_ALL',
  UNSUBSCRIBE_CODE_TYPE_BETTER_DEAL_ALERT = 'UNSUBSCRIBE_CODE_TYPE_BETTER_DEAL_ALERT',
  UNSUBSCRIBE_CODE_TYPE_HOME_REPORT = 'UNSUBSCRIBE_CODE_TYPE_HOME_REPORT',
  UNSUBSCRIBE_CODE_TYPE_MORTGAGE_UPDATE = 'UNSUBSCRIBE_CODE_TYPE_MORTGAGE_UPDATE',
  UNRECOGNIZED = 'UNRECOGNIZED',
}
